import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AiInterviewCompany } from '@edtech-ui/core/models/ai-interview/interview-companys';
import { AiInterviewServiceService } from '@edtech-ui/core/services/ai-interview-service/ai-interview-service.service';
import { ToastrService } from 'ngx-toastr';
import { CompanyCreateDailogComponent } from '../../company-create-dailog/company-create-dailog.component';
import { AiInterviewSessionService } from '@edtech-ui/core/services/ai-interview-session-service/ai-interview-session.service';

@Component({
  selector: 'app-step-add-context',
  standalone: true,
  imports: [CommonModule, FormsModule, CompanyCreateDailogComponent],
  templateUrl: './step-add-context.component.html',
  styleUrl: './step-add-context.component.scss'
})
export class StepAddContextComponent {
  @Output() continue = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  contextText = '';
  jobDescription = '';

  isDropdownOpen = false;
  searchTerm = '';
  selectedCompany: AiInterviewCompany | null = null;

  companies: AiInterviewCompany[] = [];
  filteredCompanies: AiInterviewCompany[] = [];

  uploadedFile: File | null = null;
  uploadedFileSize = '';

  loadingCompanies = false;
  private readonly MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
   MAX_DESC_LENGTH = 2000;

  constructor(
    private aiInterviewService: AiInterviewServiceService,
    private toast: ToastrService,
    private session: AiInterviewSessionService
  ) { }

  ngOnInit(): void {
    this.loadCompanies();
    const saved = this.session.value;

    if (saved.company_id) {
      this.selectedCompany = { id: saved.company_id, name: saved.company_name || '' } as AiInterviewCompany;
      this.searchTerm = saved.company_name || '';
    }
    if (saved.job_description) this.jobDescription = saved.job_description;
    if (saved.resume_file) this.uploadedFile = saved.resume_file as File;
  }

  loadCompanies(): void {
    this.loadingCompanies = true;

    this.aiInterviewService.getCompaniesList().subscribe({
      next: (response) => {
        this.loadingCompanies = false;
        if (response?.Success && response.Data?.length) {
          this.companies = response.Data;
          this.filteredCompanies = [...response.Data];
        } else {
          this.toast.warning(response?.Message || 'No companies found.');
        }
      },
      error: (err) => {
        this.loadingCompanies = false;
        console.error('Error fetching companies:', err);
        this.toast.error('Failed to load companies. Please try again later.');
      }
    });
  }

  openDropdown(): void {
    this.isDropdownOpen = true;
  }

  filterCompanies(): void {
    const search = this.searchTerm.toLowerCase();
    this.filteredCompanies = this.companies.filter((c) =>
      c.name.toLowerCase().includes(search)
    );
  }

  selectCompany(company: AiInterviewCompany, event?: MouseEvent): void {
    if (event) event.stopPropagation();

    this.selectedCompany = company;
    this.searchTerm = company.name;
    this.isDropdownOpen = false;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;
    if (file.size > this.MAX_FILE_SIZE) {
      this.toast.error('File size must be 10 MB or less');
      input.value = '';
      this.uploadedFile = null;
      this.uploadedFileSize = '';
      return;
    }

    this.uploadedFile = file;
    this.uploadedFileSize = this.formatFileSize(file.size);
  }


  removeFile(): void {
    this.uploadedFile = null;
    this.uploadedFileSize = '';
  }

  formatFileSize(size: number): string {
    const kb = size / 1024;
    return kb < 1024 ? `${kb.toFixed(2)} KB` : `${(kb / 1024).toFixed(2)} MB`;
  }


//   onContinue() {
//     this.session.update({
//       company_id: this.selectedCompany?.id || 0,
//       company_name: this.selectedCompany?.name || undefined,
//       job_description: this.jobDescription || null,
//       resume_file: this.uploadedFile || null,
//     });
//     this.continue.emit();
//   }

	onContinue() {
		if (this.jobDescription.length >= this.MAX_DESC_LENGTH) {
			this.toast.warning('Please reduce the job description below 2000 characters to continue.'	);
			return;
		}

		this.session.update({
			company_id: this.selectedCompany?.id || 0,
			company_name: this.selectedCompany?.name || undefined,
			job_description: this.jobDescription || null,
			resume_file: this.uploadedFile || null,
		});

		this.continue.emit();
	}

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const clickedInside = target.closest('.dropdown-container');

    if (!clickedInside) {
      this.isDropdownOpen = false;
    }
  }

  showCreateCompanyModal = false;

  openCreateCompanyModal() {
    this.isDropdownOpen = false;
    this.showCreateCompanyModal = true;
  }

  handleCompanyCreated(newCompany: AiInterviewCompany) {
    this.companies.push(newCompany);
    this.filteredCompanies = [...this.companies];
    this.selectCompany(newCompany);
    this.toast.success('New company added successfully!');
  }

	onJobDescriptionChange(): void {
		if (this.jobDescription.length === this.MAX_DESC_LENGTH) {
			this.toast.warning('Job description Please reduce characters to continue.');
		}
	}

}